<template>
    <el-dialog
            :title="dakatitle"
            :visible="showspModel"
            :close-on-click-modal="!showspModel"
            :before-close="close"
            width="600px"
    >
            <div class="Spicontent">
            <el-form ref="form" :model="spModel" label-width="100px" :rules="rules">
                <el-form-item label="赞助商名称" prop="SponsorName">
                    <el-input v-model.trim="spModel.SponsorName" maxlength="100" placeholder="请输入赞助商名称" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="赞助商网址" prop="SponsorSiteUrl">
                    <el-input v-model.trim="spModel.SponsorSiteUrl" maxlength="1000" placeholder="请输入赞助商网址" class="edit_input" style="width: 410px;"></el-input>
                </el-form-item>
                <el-form-item label="介绍" prop="SponsorIntroduce">
                    <el-input type="textarea" v-model.trim="spModel.SponsorIntroduce" maxlength="1000" placeholder="请输入赞助商介绍" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="LOGO" prop="LogoUrl" class="mask">
                    <el-upload
                            :action="url"
                            list-type="picture-card"
                            accept=".jpg, .jpeg, .png,.gif,.bmp"
                            :file-list="fileList"
                            :limit="imgLimitNum"
                            :before-upload="beforeAvatarUpload"
                            :on-exceed="handlePicOutLimit"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                            :on-success="successUpload"
                            :class="{hide:hideUpload}">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="tips">请上传图片，格式包括gif、png、jpg、jpeg、bmp，大小不超过10M</span>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                <el-button type="danger" v-if="spModel.Id!=-1" @click="deleteVideo()">删除</el-button>
                <el-button type="primary" @click="push('form')">确认</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </el-dialog>
</template>

<script>
    import apiEnv from "@/service/apiEnv.js";
    import {deleteSponsor,setSponsor} from "@/service/run";
    export default {
        name: "sponPopup",
        props:{
            currentParam:{
                type:Object,
                default(){return {}}
            }
        },
        data(){
            const valImgUrl = (rule, value, callback) => { //视频验证
                if (!this.spModel.LogoUrl) {
                    callback(new Error('LOGO不能为空!'));
                } else {
                    callback();
                }
            }
            return{
                rules:{
                    SponsorName: [{required:true, message: '请输入赞助商名称！', trigger: 'blur'}],
                    SponsorSiteUrl: [{required:true, message: '请输入赞助商网址！', trigger: 'blur'}],
                    SponsorIntroduce: [{required:true, message: '请输入赞助商介绍！', trigger: 'blur'}],
                    LogoUrl:[{required:true,validator:valImgUrl, trigger: 'change'}],
                },
                // 新增大咖
                dakatitle:'',
                showspModel:true,
                spModel:{
                    SponsorName:'',
                    SponsorSiteUrl:'',
                    SponsorIntroduce:'',
                    LogoUrl:'',
                    Id:0
                },
                url: apiEnv.uploadURL,
                imgLimitNum:1,
                fileList:[],
                dialogVisible:false,
                dialogImageUrl: "",     //点击查看的url
                hideUpload:false,
                fileList2:[],
                progress: 0, //进度条数据
                videoFlag:false
            }
        },
        methods:{
            // 大咖
            close(){
                this.$emit("close")
            },
            beforeAvatarUpload(file){
                const isLt2M = file.size / 1024 / 1024 < 10,
                    limitStr = ['《','》','%','#','*',";","[","]","【","】",'{','}',"&","$"],
                    bool = limitStr.find((x)=>{return file.name.indexOf(x)>-1})?false:true;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 10MB!');
                }
                if(!bool){
                    this.$message.error('图片命名不得包含非法字符!');
                }
                return isLt2M && bool;
            },
            handlePicOutLimit(){
                this.$message.warning("最多只能上传一张图片哦！")
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = "";
                this.dialogImageUrl = file.response ?
                    file.response.Data[0].imgUrl :
                    file.url;
                this.dialogVisible = true;
            },
            handleRemove(file, fileList) {
                this.spModel.LogoUrl = ''
                this.$refs.form.validateField(['LogoUrl'])
                this.hideUpload = false;
                console.log(file, fileList);
            },
            successUpload(res){
                if(res.Result != 1) {
                    this.fileList = []
                    this.$refs.form.validateField('LogoUrl');
                    return this.$message.error(res.Message)
                }
                let simageUrl =res.Data[0].imgUrl
                this.spModel.LogoUrl =simageUrl;
                this.$refs.form.clearValidate('LogoUrl');
                this.hideUpload = true;
            },
            push(formName){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        //新建或更新
                        if (this.spModel.Id == -1) {
                            this.newMeg(-1)
                        } else {
                            this.newMeg(1)
                        }
                    }
                })
            },
            newMeg(index){
                var params = {
                    SponsorName:this.spModel.SponsorName,
                    SponsorSiteUrl:this.spModel.SponsorSiteUrl,
                    SponsorIntroduce:this.spModel.SponsorIntroduce,
                    LogoUrl:this.spModel.LogoUrl
                };
                if(index==1){
                    params.Id=this.spModel.Id;
                }
                setSponsor(params).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                    this.$emit("refreshList")
                })
            },
            deleteVideo(){
                let data = {
                    Id: this.spModel.Id
                }
                deleteSponsor(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error('删除失败，请重新确认删除');
                    }
                    this.$message.success('删除成功！');
                    this.$emit("refreshList")
                })
            },
        },
        mounted() {
            console.log("this.currentParam",this.currentParam)
            const param = this.currentParam;
            if(this.currentParam.Id!=-1){
                this.spModel.SponsorName = param.SponsorName;
                this.spModel.SponsorSiteUrl = param.SponsorSiteUrl;
                this.spModel.SponsorIntroduce = param.SponsorIntroduce;
                this.$nextTick(()=>{
                    // debugger
                    this.fileList = [{
                        name:'',
                        url:param.LogoUrl
                    }]
                    if(this.fileList.length>0){
                        this.hideUpload = true;
                    }
                })
                this.spModel.LogoUrl = param.LogoUrl;
                this.$nextTick(()=>{
                    // debugger
                    this.fileList2 = [{
                        name:'',
                        url:param.LogoUrl
                    }]
                });
            }
            this.spModel.Id=param.Id;
            if (param.Id==-1) {
                this.dakatitle='新增赞助商';
            }else {
                this.dakatitle='编辑赞助商';
            }
        }
    }
</script>

<style lang="scss">
    .Spicontent{
        .el-textarea__inner{
            min-height: 120px!important;
        }
        .hide .el-upload--picture-card {
            display: none;
        }
        .avatar-uploader-icon {
            margin-top: 67px;
        }
        .timeDom {
            display: block;
            position: absolute;
            padding: 2px;
            color: #fff;
            top: 0;
            right: 0;
            z-index: 999;
            background: #000;

            .videoIcon2 {
                height: 18px;
                width: auto;
                vertical-align: text-bottom;
                margin-left: 5px;
            }
        }
        .avatar,
        .el-upload-dragger {
            width: 148px;
            height: 148px;
        }
        .tipsCls {
            margin-left: 10px;
        }
        .videoIcon .el-form-item__label::before {
            content: "* ";
            color: red;
        }
        .avatar-uploader-icon {
            margin-top: 67px;
        }
        .el-upload-list--text{
            display: none;
        }
        .dialog-footer{
            .el-button{
                margin: 0px 50px;
            }
        }
        .el-form-item__content{
            margin-bottom: 10px;
        }
    }

</style>
